export enum AccountTypes {
    Unknown = 1,
    Sandbox = 2,
    Paper = 3,
    Live = 4,
}
